import { useState } from 'react';
import { DialogConfirmacao } from '../shared/components/DialogConfirmacao';

/**
 * Confirmação para ações destrutivas fora do ButtonMenu.
 *
 * [AJUSTE 11/08/2026] A maioria das exclusões passa pelo ButtonMenu, que já pede
 * confirmação pelo campo `confirmar`. Duas telas têm botão próprio (o ícone de
 * lixeira do Fornecedor e a exclusão de intervalo de parcela na Forma de
 * Pagamento) e o cancelamento de boleto usava o confirm() do navegador.
 *
 * Este hook cobre esses casos com o MESMO diálogo, para a experiência não variar
 * de tela para tela.
 *
 * Uso:
 *   const { confirmar, dialogoConfirmacao } = useConfirmacao();
 *   ...
 *   onClick={() => confirmar('Excluir o fornecedor X?', () => handleDeleteItem(id))}
 *   ...
 *   {dialogoConfirmacao}
 */
export const useConfirmacao = () => {
  const [pendente, setPendente] = useState<{
    mensagem: string;
    acao: () => void;
    titulo?: string;
    textoConfirmar?: string;
  } | null>(null);

  const confirmar = (
    mensagem: string,
    acao: () => void,
    opcoes?: { titulo?: string; textoConfirmar?: string }
  ) => {
    setPendente({ mensagem, acao, ...opcoes });
  };

  const dialogoConfirmacao = (
    <DialogConfirmacao
      aberto={pendente !== null}
      mensagem={pendente?.mensagem ?? ''}
      titulo={pendente?.titulo}
      textoConfirmar={pendente?.textoConfirmar}
      onCancelar={() => setPendente(null)}
      onConfirmar={() => {
        const acao = pendente?.acao;
        setPendente(null);
        acao?.();
      }}
    />
  );

  return { confirmar, dialogoConfirmacao };
};
